
<script lang="ts">
  import prettyBytes from 'pretty-bytes';
  export let bytes: number;
  $: pretty = prettyBytes(bytes);
</script>

{pretty}